var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"status-badge",class:[_vm.statusClass, _vm.historico ? 'historico' : '']},[_vm._v("\n  "+_vm._s(_vm.formattedStatus)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }